/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: <Ravi Ranjan Kumar,  Mylavarapu Sarath Sai, Amal Sabu, Sanket, Ujjwal Singh >

*/
import { client } from "./";
import { loadModel } from "common/load-model-util";
import isOnline from "is-online";
import {
  saveReportContent,
  getReportContentList,
} from "database/offlineDb/indexDb";
//data
import {
  reportContentNormal,
  reportContentOther,
  reportContentAbnormal,
  reportContent,
  lookupTable,
  reportContentD1,
  reportContentD2,
} from "data/data";
import {
  diseaseListFromSessionStorage,
  clinicalFeaturesListFromSessionStorage,
  differentialDiagnosisListFromSessionStorage,
  secondaryFindingsListFromSessionStorage,
  getAuthTokenFromSessionStorage,
  diagnosticTestsFromSessionStorage,
  recommendationsListFromSessionStorage,
} from "helpers/common";

export function getPostList(userId) {
  return (dispatch) => {
    dispatch({
      type: "GET_POST_LIST",
      payload: client.get(
        "api.json?rss_url=https://medium.com/feed/@KonradDaWo"
      ),
    });
  };
}
export function getReportContent() {
  const authToken = getAuthTokenFromSessionStorage();
  if (authToken !== undefined && authToken !== "") {
    const baseReportContent = [
      reportContentNormal,
      reportContentOther,
      reportContentAbnormal,
      reportContentD1,
      reportContentD2,
    ];
    return (dispatch) => {
      dispatch({
        type: "GET_REPORT_CONTENT",
        payload: client
          .get("/diagonosis", {
            headers: {
              authorization: authToken,
            },
          })
          .then((res) => {
            const completeReportContent = baseReportContent.concat(res?.data);
            saveReportContent(completeReportContent);
            return res;
          })
          .catch((err) => {
            console.log(
              "fetching report content failed going with baseReportContent, err:",
              err
            );

            // saveReportContent(baseReportContent);

            return { data: baseReportContent };
          }),
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: "GET_REPORT_CONTENT",
        payload: {
          data: [
            reportContentNormal,
            reportContentOther,
            reportContentAbnormal,
          ],
        },
      });
    };
  }
}

export function getReportContentFromIDB() {
  return (dispatch) => {
    dispatch({
      type: "GET_REPORT_CONTENT",
      payload: getReportContentList().then((res) => {
        return res;
      }),
    });
  };
}
export function getSymptoms(id) {
  const authToken = getAuthTokenFromSessionStorage();
  let symptomId = id !== undefined ? id : "";
  return function (dispatch) {
    client
      .get("/symptom/" + symptomId, {
        headers: {
          authorization: authToken,
        },
      })
      .then((response) => {
        sessionStorage.setItem("symptomsList", JSON.stringify(response.data));
        let symptomsList =
          sessionStorage.getItem("symptomsList") !== undefined &&
          sessionStorage.getItem("symptomsList") !== null
            ? JSON.parse(sessionStorage.getItem("symptomsList"))
            : [];
        if (symptomsList.length !== 0) {
          dispatch({
            type: "GET_ALL_SYMPTOMS_LIST_FULFILLED",
            payload: { data: symptomsList },
          });
        }
        //  else {
        //   dispatch({
        //     type: "GET_ALL_SYMPTOMS_LIST_FULFILLED",
        //     payload: response,
        //   });
        // }
        else {
          console.log(
            `Fetching symptoms list failed, reason:${JSON.stringify(response)}`
          );
        }
      });
  };
  // return dispatch => {
  //   dispatch({
  //     type: 'GET_ALL_SYMPTOMS_LIST',
  //     payload: client.get('/symptom/' + symptomId, {
  //       headers: {
  //         "Accept": "*/*",
  //         "authorization": authToken
  //       },
  //     })
  //   })
  // }
}
export function getDiagnosableModel(session) {
  return (dispatch) => {
    dispatch({
      type: "GET_MODEL_DATA_FULFILLED",
      payload: session,
    });
  };
}
export function getNetSpeed(speedData) {
  return (dispatch) => {
    dispatch({
      type: "GET_NET_SPEED_FULFILLED",
      payload: speedData,
    });
  };
}
export function getNetConnectivity() {
  return (dispatch) => {
    dispatch({
      type: "GET_NET_CONNECTIVITY",
      payload: isOnline(),
    });
  };
}
// -----for store-----
export function updateUserAgent(value) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_USER_AGENT_DATA",
      payload: value,
    });
  };
}

export function getThemeData(value) {
  return (dispatch) => {
    dispatch({
      type: "GET_THEME_DATA",
      payload: value,
    });
  };
}
export function updateLogOutModel(value) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_LOGOUT_MODEL",
      payload: value,
    });
  };
}
export function updateHelpMenuModel(value){
  return (dispatch) => {
    dispatch({
      type:"UPDATE_HELP_MENU_MODEL",
      payload:value,
    })
  }
}
export function updateLoginModel(value) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_LOGIN_MODEL",
      payload: value,
    });
  };
}
export function updateDynamicFormData(field, value) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_DYNAMIC_FORMDATA",
      payload: { field, value },
    });
  };
}

export function changePortalModalState(value) {
  return (dispatch) => {
    dispatch({
      type: "CHANGE_PORTAL_MODAL_STATE",
      payload: value,
    });
  };
}

export const getOrgzFeaturesAction =
  (isCurrentUserAConsultant) => async (dispatch) => {
    try {
      const authToken = getAuthTokenFromSessionStorage();
      const res = await client.get("/orgz-features", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });

      return dispatch({
        type: "GET_ORGZ_FEATURES",
        payload: { ...res.data.orgzFeatures, isCurrentUserAConsultant },
      });
    } catch (error) {
      console.log("getOrgzFeaturesAction error", error);
    }
  };

//--------For singleImageManipulator--------------------------------
export const getDiseaseList = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const diseaseList = diseaseListFromSessionStorage();
  if (!diseaseList.length) {
    try {
      const res = await client.get("/disease-list", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem("disease-list", JSON.stringify(res.data));
      dispatch({ type: "SET_DISEASE_LIST", payload: res.data });
    } catch (diseaseListFetchError) {
      return console.log({ diseaseListFetchError });
    }
  } else {
    dispatch({
      type: "SET_DISEASE_LIST",
      payload: diseaseList,
    });
  }
};

export const getClinicalFeaturesList = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const clinicalFeaturesList = clinicalFeaturesListFromSessionStorage();
  if (!clinicalFeaturesList.length) {
    try {
      const res = await client.get("/dis-cf", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem(
        "clinical-features-list",
        JSON.stringify(res.data)
      );
      dispatch({ type: "SET_CLINICAL_FEATURES_LIST", payload: res.data });
    } catch (fetchClinicalFeaturesListError) {
      console.log({ fetchClinicalFeaturesListError });
    }
  } else {
    dispatch({
      type: "SET_CLINICAL_FEATURES_LIST",
      payload: clinicalFeaturesList,
    });
  }
};

// export const getHelpMenuData =(authToken)=>async(dispatch)=>{
//   authToken = authToken || getAuthTokenFromSessionStorage();
//   try{
//     const res = await client.get("/get-help-menu",{
//       withCredentials: true,
//       headers: {
//         Accept: "*/*",
//         authorization: authToken,
//       },
//     })

//   }catch(err){
//     console.log(err)
//   }
// }
export const getDifferentailDiagnosisList = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const diffDiagList = differentialDiagnosisListFromSessionStorage();
  if (!diffDiagList.length) {
    try {
      const res = await client.get("/diff-diag-list", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem(
        "differential-diagnosis-list",
        JSON.stringify(res.data)
      );
      dispatch({ type: "SET_DIFFERENTIAL_DIAGNOSIS_LIST", payload: res.data });
    } catch (fetchDifferentialDiagnosisListError) {
      console.log({ fetchDifferentialDiagnosisListError });
    }
  } else {
    dispatch({
      type: "SET_DIFFERENTIAL_DIAGNOSIS_LIST",
      payload: diffDiagList,
    });
    // return diseaseListFromSessionStorage;
  }
};

export const getSecondaryFindingsList = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const secFindingsList = secondaryFindingsListFromSessionStorage();
  if (!secFindingsList.length) {
    try {
      const res = await client.get("/sec-findings-list", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem(
        "secondary-findings-list",
        JSON.stringify(res.data)
      );
      dispatch({ type: "SET_SECONDARY_FINDINGS_LIST", payload: res.data });
    } catch (fetchSecondaryFindingsListError) {
      console.log({ fetchSecondaryFindingsListError });
    }
  } else {
    dispatch({
      type: "SET_SECONDARY_FINDINGS_LIST",
      payload: secFindingsList,
    });
  }
};

export const getDiagnosticTests = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const diagnosticTestsList = diagnosticTestsFromSessionStorage();
  // console.log(diagnosticTestsList, "diagnosticTests");
  if (!diagnosticTestsList.length) {
    try {
      const res = await client.get("/diagnostic-tests", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem("diagnostic-tests-list", JSON.stringify(res.data));
      dispatch({ type: "SET_DIAGNOSTIC_TESTS_LIST", payload: res.data });
    } catch (error) {
      console.log({ error });
    }
  } else {
    dispatch({
      type: "SET_DIAGNOSTIC_TESTS_LIST",
      payload: diagnosticTestsList,
    });
  }
};

export const getrecommendationsList = (authToken) => async (dispatch) => {
  authToken = authToken || getAuthTokenFromSessionStorage();
  const recommendationsList = recommendationsListFromSessionStorage();
  if (!recommendationsList.length) {
    try {
      const res = await client.get("/recommendations-list", {
        withCredentials: true,
        headers: {
          Accept: "*/*",
          authorization: authToken,
        },
      });
      sessionStorage.setItem(
        "recommendations-list",
        JSON.stringify(res.data.recommendationsList)
      );
      dispatch({
        type: "SET_RECOMMENDATIONS_LIST",
        payload: res.data.recommendationsList,
      });
    } catch (error) {
      console.log({ error });
    }
  } else {
    dispatch({
      type: "SET_RECOMMENDATIONS_LIST",
      payload: recommendationsList,
    });
  }
};

export const getHelpMenuData=()=>async (dispatch) => {
  try {
    const response = await client.get(`/getHelpMenuData`, {
      headers: {
        authorization: getAuthTokenFromSessionStorage(),
      },
    });
    sessionStorage.setItem(
      "helpMenu-list",
      JSON.stringify(response.data.helpMenuData[0])
    );
    dispatch({
      type: "SET_HELP_MENU_DATA_LIST",
      payload: response.data.helpMenuData[0],
    });
    console.log("Data of HelpMenu in action", response.data.helpMenuData[0]);
  } catch (error) {
    console.error("Error fetching helpmenu data:", error);
  }
}